import vm from '~/main'
export default {
  $scrollToElementById: ({ target, targetId, smooth = true, block }) => {
    vm.$nextTick(function () {
      let searchTarget
      if (!target && targetId) {
        searchTarget = document.getElementById(targetId)
      }
      const scrollElement = target || searchTarget
      // https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoView
      scrollElement.scrollIntoView({
        behavior: smooth ? 'smooth' : 'auto',
        block: block || 'nearest',
        inline: 'nearest',
      })
    })
  },
  $scrollToBottom: ({ target, targetId, smooth = true }) => {
    console.log('scrollToBottom', { target, targetId })
    vm.$nextTick(function () {
      let searchTarget
      if (!target && targetId) {
        searchTarget = document.getElementById(targetId)
      }
      const scrollElement = target || searchTarget || window
      // https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollTo
      scrollElement.scrollTo({
        top: scrollElement.scrollHeight,
        behavior: smooth ? 'smooth' : 'auto',
      })
    })
  },
}
